













import Vue, {PropType} from 'vue';
import {Util} from '@/util/util';

interface Data {
    data: any[];
}
interface Methods {
    iconPath: (iconName: string) => string,
    iconFileName: (iconName: string) => string,
}

interface Computed {
    resourcePath: string
}
interface Props {
    title: string,
    json: object[];
}

export default Vue.extend<Data, Methods, Computed, Props>({
    props: {
        title: {
            type: String,
            required: true
        },
        json: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            data: []
        }
    },
    methods: {
        iconFileName(iconName: string): string {
            return iconName.replace(/\s/g, "").toLowerCase();
        },
        iconPath(iconName: string): string {
            const relativePath = "/dist/img/specs/";
            return this.resourcePath + relativePath + this.iconFileName(iconName) + ".svg";
        }
    },
    computed: {
        resourcePath(): string {
            return Util.getConfig().resourcePath;
        }
    },
    mounted(): void {
        this.$data.data = this.json;
    }
})
